export const assetFolder = '/img/parallex-gallery/';
